export class HttpImageService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  async upload(file) {
    const data = new FormData();
    data.append('image', file);

    const res = await fetch(`${this.baseUrl}/api/v1/images`, {
      method: 'POST',
      body: data,
      credentials: 'include',
    });

    if (!res.ok) {
      throw new Error('Error uploading image');
    }

    return res.json();
  }
}
